"use strict";

var _slicedToArray = require("/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = void 0;

function parse(s) {
  try {
    return JSON.parse(s);
  } catch (e) {
    var _parseAny = parseAny(s, e),
        _parseAny2 = _slicedToArray(_parseAny, 2),
        data = _parseAny2[0],
        reminding = _parseAny2[1];

    parse.lastParseReminding = reminding;

    if (parse.onExtraToken && reminding.length > 0) {
      parse.onExtraToken(s, data, reminding);
    }

    return data;
  }
}

exports.parse = parse;

(function (parse) {
  parse.onExtraToken = function (text, data, reminding) {
    console.error('parsed json with extra tokens:', {
      text: text,
      data: data,
      reminding: reminding
    });
  };
})(parse = exports.parse || (exports.parse = {}));

function parseAny(s, e) {
  var parser = parsers[s[0]];

  if (!parser) {
    console.error("no parser registered for ".concat(JSON.stringify(s[0]), ":"), {
      s: s
    });
    throw e;
  }

  return parser(s, e);
}

var parsers = {};

function skipSpace(s) {
  return s.trimLeft();
}

parsers[' '] = parseSpace;
parsers['\r'] = parseSpace;
parsers['\n'] = parseSpace;
parsers['\t'] = parseSpace;

function parseSpace(s, e) {
  s = skipSpace(s);
  return parseAny(s, e);
}

parsers['['] = parseArray;

function parseArray(s, e) {
  s = s.substr(1); // skip starting '['

  var acc = [];
  s = skipSpace(s);

  for (; s.length > 0;) {
    if (s[0] === ']') {
      s = s.substr(1); // skip ending ']'

      break;
    }

    var res = parseAny(s, e);
    acc.push(res[0]);
    s = res[1];
    s = skipSpace(s);

    if (s[0] === ',') {
      s = s.substring(1);
      s = skipSpace(s);
    }
  }

  return [acc, s];
}

var _iterator = _createForOfIteratorHelper('0123456789.-'.slice()),
    _step;

try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var c = _step.value;
    parsers[c] = parseNumber;
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

function parseNumber(s) {
  for (var i = 0; i < s.length; i++) {
    var c = s[i];

    if (parsers[c] === parseNumber) {
      continue;
    }

    var num = s.substring(0, i);
    s = s.substring(i);
    return [numToStr(num), s];
  }

  return [numToStr(s), ''];
}

function numToStr(s) {
  if (s === '-') {
    return -0;
  }

  var num = +s;

  if (Number.isNaN(num)) {
    return s;
  }

  return num;
}

parsers['"'] = parseString;

function parseString(s) {
  for (var i = 1; i < s.length; i++) {
    var c = s[i];

    if (c === '\\') {
      i++;
      continue;
    }

    if (c === '"') {
      var str = s.substring(0, i + 1);
      s = s.substring(i + 1);
      return [JSON.parse(str), s];
    }
  }

  return [JSON.parse(s + '"'), ''];
}

parsers['{'] = parseObject;

function parseObject(s, e) {
  s = s.substr(1); // skip starting '{'

  var acc = {};
  s = skipSpace(s);

  for (; s.length > 0;) {
    if (s[0] === '}') {
      s = s.substr(1); // skip ending '}'

      break;
    }

    var keyRes = parseAny(s, e);
    var key = keyRes[0];
    s = keyRes[1];
    s = skipSpace(s);

    if (s[0] !== ':') {
      acc[key] = undefined;
      break;
    }

    s = s.substr(1); // skip ':'

    s = skipSpace(s);

    if (s.length === 0) {
      acc[key] = undefined;
      break;
    }

    var valueRes = parseAny(s, e);
    acc[key] = valueRes[0];
    s = valueRes[1];
    s = skipSpace(s);

    if (s[0] === ',') {
      s = s.substr(1);
      s = skipSpace(s);
    }
  }

  return [acc, s];
}

parsers['t'] = parseTrue;

function parseTrue(s, e) {
  return parseToken(s, "true", true, e);
}

parsers['f'] = parseFalse;

function parseFalse(s, e) {
  return parseToken(s, "false", false, e);
}

parsers['n'] = parseNull;

function parseNull(s, e) {
  return parseToken(s, "null", null, e);
}

function parseToken(s, tokenStr, tokenVal, e) {
  for (var i = tokenStr.length; i >= 1; i--) {
    if (s.startsWith(tokenStr.slice(0, i))) {
      return [tokenVal, s.slice(i)];
    }
  }
  /* istanbul ignore next */


  {
    var prefix = JSON.stringify(s.slice(0, tokenStr.length));
    console.error("unknown token starting with ".concat(prefix, ":"), {
      s: s
    });
    throw e;
  }
}